/**
 * Created by Ning Jiang on 2023-08-31.
 */

import {WinPresentationController} from "../WinPresentationController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";

export class AvalancheController extends WinPresentationController {

    constructor() {
        super("AvalancheController", false);
    }

    protected hasWin():boolean {
        return DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.NORMAL_AVALANCHE;
    }

    protected async createWinAnimation():Promise<any> {
        return DevilsCrossRoad.reels.avalanche();
    }
}